import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  Box,
  Modal,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PublicIcon from '@mui/icons-material/Public';
import EventIcon from '@mui/icons-material/Event';
import ConstructionIcon from '@mui/icons-material/Construction'; 
import PetsIcon from '@mui/icons-material/Pets';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import '../pages/Gallery.css';

const gallerySections = {
  village: [

     //{ src: '/viral.mp4', title: ' ' ,type:'video'},
    
  ],
  events: [
   
    { src: 'development/d1.jpg', title: '' ,type:'image'},
    { src: 'development/d2.jpg', title: '' ,type:'image'},
    { src: 'development/d3.jpg', title: 'घंटा गाडी  स्वच्छतेची सेवा तुमच्या दारी' ,type:'image'},
    { src: 'development/d4.jpg', title: 'सौर प्रकाश – गावाचा विकास' ,type:'image'},
    { src: 'development/d16.jpg', title: 'शौचालयाचा वापर, आरोग्याचा आधार' ,type:'image'},
    { src: 'development/d5.jpg', title: '' ,type:'image'},
    { src: 'development/d6.jpg', title: '' ,type:'image'},
    { src: 'development/d7.jpg', title: 'सांडपाणी व्यवस्थापन रोगमुक्त परिसर' ,type:'image'},
    { src: 'development/d8.jpg', title: 'सांडपाणी व्यवस्थापन रोगमुक्त परिसर' ,type:'image'},
    { src: 'development/d9.jpg', title: 'सांडपाणी व्यवस्थापन रोगमुक्त परिसर' ,type:'image'},
    { src: 'development/d10.jpg', title: 'सांडपाणी व्यवस्थापन रोगमुक्त परिसर' ,type:'image'},
    { src: 'development/d11.jpg', title: 'सांडपाणी व्यवस्थापन रोगमुक्त परिसर' ,type:'image'},
    { src: 'development/d12.jpg', title: 'सांडपाणी व्यवस्थापन रोगमुक्त परिसर' ,type:'image'},
    { src: 'development/d15.jpg', title: 'तलाव सुशोभीकरण ' ,type:'image'},
    { src: 'development/d13.jpg', title: 'तलाव सुशोभीकरण ' ,type:'image'},
    { src: 'development/d17.jpg', title: 'तलाव सुशोभीकरण ' ,type:'image'},
    { src: 'development/d14.jpg', title: ' ' ,type:'image'},
  ],
  development: [
    { src: 'function/f1.jpg', title: '', type: 'image' },
    { src: 'function/f2.jpg', title: '' ,type:'image'},
    { src: 'function/f3.jpg', title: '' ,type:'image'},
    { src: 'function/f4.jpg', title: '' ,type:'image'},
    { src: 'function/f5.jpg', title: '' ,type:'image'},
    { src: 'function/f6.jpg', title: '' ,type:'image'},
    { src: 'function/f7.jpg', title: '' ,type:'image'},
    { src: 'function/f8.jpg', title: '' ,type:'image'},
    { src: 'function/f9.jpg', title: '' ,type:'image'},
    { src: 'function/f10.jpg', title: '' ,type:'image'},
    { src: 'function/f11.jpg', title: '' ,type:'image'},
    { src: 'function/f12.jpg', title: '' ,type:'image'},
    { src: 'function/f13.jpg', title: '' ,type:'image'},
    { src: 'function/f14.jpg', title: '' ,type:'image'},
    
  ],
  wwf: [


    // { src: '#', title: '' ,type:'image'},
    // { src: '#', title: '' ,type:'image'},
  ],
  newspaper: [
   { src: '#', title: '' ,type:'image'},
  { src: '#', title: '' ,type:'image'},
    
  ],
};


const tabLabels = [
 { label: 'इंटरनेट Virals', icon: <PublicIcon sx={{ color: '#1976D2' }} /> },
 { label: 'विकास', icon: <ConstructionIcon  sx={{ color: '#4CAF50' }} /> }, 
  { label: 'कार्यक्रम', icon: <EventIcon sx={{ color: '#E91E63' }} /> },
  // { label: 'WWF संरक्षण', icon: <PetsIcon sx={{ color: '#FF9800' }} /> },
  //{ label: 'बातम्या कात्रण', icon: <NewspaperIcon sx={{ color: '#9C27B0' }} /> },
];

const Gallery = () => {
  const [selectedMediaIndex, setSelectedMediaIndex] = useState<number | null>(null);
  const [currentCategory, setCurrentCategory] = useState<keyof typeof gallerySections>('village');
  const [tabValue, setTabValue] = useState(0);

  const handleMediaClick = (index: number, type: string) => {
   
    if (type === 'video') {
      const videoElement = document.getElementById('modal-video') as HTMLVideoElement;
      if (videoElement) {
        videoElement.play(); 
      }
    }
    setSelectedMediaIndex(index);
  };

  const handleClose = () => {
   
    const videoElement = document.getElementById('modal-video') as HTMLVideoElement;
    if (videoElement) {
      videoElement.pause();
      videoElement.currentTime = 0;
    }
    setSelectedMediaIndex(null);
  };

  const handlePrevious = () =>
    setSelectedMediaIndex((prev) => (prev ? prev - 1 : gallerySections[currentCategory].length - 1));
  const handleNext = () =>
    setSelectedMediaIndex((prev) =>
      prev !== null ? (prev < gallerySections[currentCategory].length - 1 ? prev + 1 : 0) : null
    );
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setCurrentCategory(Object.keys(gallerySections)[newValue] as keyof typeof gallerySections);
  };

  return (
    <Box sx={{ py: 6, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h3" gutterBottom>फोटो गॅलरी</Typography>
          <Typography variant="h6" color="text.secondary">आमच्या गावाचे सौंदर्य आणि विकास पहा</Typography>
        </Box>


       {/* Responsive Tabs with Colors */}
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          width: "100%", 
          display: "flex",
          
          justifyContent: "center", 
          alignItems: "center",
          "& .MuiTabs-flexContainer": {
            justifyContent: "center", 
            flexWrap: "wrap", 
          },
          "& .MuiTab-root": {
            minWidth: "auto",
            padding: "10px 16px",
      fontSize: "1rem",
    },
  }}
>
  {tabLabels.map((tab, index) => (
    <Tab key={index} icon={tab.icon} label={tab.label} />
  ))}
</Tabs>





        <Grid container spacing={3} sx={{ mt: 3 }}>
          {gallerySections[currentCategory].map((media, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card onClick={() => handleMediaClick(index, media.type)} className="gallery-card">
                {media.type === 'video' ? (
                  <Box sx={{
                    position: 'relative',
                    width: '100%',
                    height: '200px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <video
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: 'cover', 
                        borderRadius: '8px',
                      }}
                      controls
                      onClick={(e) => e.stopPropagation()}
                    >
                      <source src={media.src} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </Box>
                ) : (
                  <CardMedia component="img" height="200" image={media.src} alt={media.title} />
                )}
                <Box className="gallery-title">
                  <Typography variant="body1">{media.title}</Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>

       {/* Media Modal */}
<Modal open={selectedMediaIndex !== null} onClose={handleClose} className="modal-container">
  <Box
    className="modal-content"
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      padding: 2,
      borderRadius: '12px',
      boxShadow: 5,
      position: 'relative', // ✅ Ensures absolute positioning of buttons works correctly
    }}
  >
    {selectedMediaIndex !== null && (
      <>
        {/* ✅ Close Button - Positioned at the Top-Right Corner */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 20, 
            right: 20,
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* ✅ Left Navigation Button */}
        <IconButton
          onClick={handlePrevious}
          sx={{
            position: 'absolute',
            left: 20,
            top: "50%",
            transform: "translateY(-50%)",
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" },
          }}
        >
          <ChevronLeftIcon />
        </IconButton>

        {/* ✅ Right Navigation Button */}
        <IconButton
          onClick={handleNext}
          sx={{
            position: 'absolute',
            right: 20,
            top: "50%",
            transform: "translateY(-50%)",
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" },
          }}
        >
          <ChevronRightIcon />
        </IconButton>

        {/* Display Media (Image or Video) */}
        {gallerySections[currentCategory][selectedMediaIndex].type === 'video' ? (
          <video
            id="modal-video"
            controls
            autoPlay
            style={{
              maxWidth: '90vw', 
              maxHeight: '90vh', 
              objectFit: 'contain', 
              borderRadius: '8px',
            }}
          >
            <source src={gallerySections[currentCategory][selectedMediaIndex].src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={gallerySections[currentCategory][selectedMediaIndex].src}
            alt={gallerySections[currentCategory][selectedMediaIndex].title}
            style={{
              maxWidth: '90%',
              maxHeight: '90vh',
              borderRadius: '8px',
            }}
          />
        )}
      </>
    )}
  </Box>
</Modal>

      </Container>
    </Box>
  );
};

export default Gallery;
